import { render } from "./select-user.vue?vue&type=template&id=2a582cd8"
import script from "./select-user.vue?vue&type=script&lang=js"
export * from "./select-user.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__